import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";
import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import AiInspectionPlushieInspectionDraft from "./ai-inspection-plushie-inspection-draft.model";

export default class AiInspectionPlushieInspectionDraftRepository extends BasicRepository<AiInspectionPlushieInspectionDraft> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<AiInspectionPlushieInspectionDraft>,
    responseParser: ApiCollectionResponseParserService<AiInspectionPlushieInspectionDraft>
  ) {
    super(
      "ai_inspection_plushie_inspection_drafts",
      api,
      objectBuilder,
      responseParser
    );
  }

  public async getByPlushieIdAndQaGroupNumber(
    plushieId: string,
    qaGroupNumber: number,
    useCache = true
  ): Promise<AiInspectionPlushieInspectionDraft | undefined> {
    const collection = await this.fetchList(
      { plushieId, qaGroupNumber },
      1,
      1,
      undefined,
      useCache
    );

    return collection.getItems()[0];
  }
}
